'use client';
import { getInviteData } from '@/api/account';
import Button from '@/components/Button';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function ReferFriend({
  SDRewardsPageBtnClick,
}: {
  SDRewardsPageBtnClick: (btnName: string) => void;
}) {
  const [res, setRes] = useState({} as any);
  const router = useRouter();
  async function getInviteDataAction() {
    const data = await getInviteData();
    setRes(data.data);
  }

  function handleStartSharing() {
    SDRewardsPageBtnClick('Start Sharing');
    router.push('/account/refer-a-friend');
  }

  useEffect(() => {
    getInviteDataAction();
  }, []);

  const t = useTranslations('account.referAFriend');
  // const currencyList = globalThis.currencyList || [];
  // const usdCurrency = currencyList.find((item) => item.name === env.NEXT_PUBLIC_DEFAULT_CURRENCY);
  const currency = useStore((state) => state.currency);
  const ratio = res?.invite_rule?.ratio;
  const pointDollar = +Math.ceil(res?.invite_rule?.refer_order?.value / +ratio) || 0;
  return (
    <>
      <WebOnly>
        <div className="container mx-auto mt-80 flex flex-col items-center gap-18 bg-[#f4f4f4] rounded-12 py-40">
          <p className="text-16 font-br text-center">{t('title')}</p>
          <h2 className="text-28 font-bb text-center whitespace-pre-line">
            {t('shareSaveAmount', {
              amount: `${formatPriceNumberWithSymbol(`${pointDollar}`, currency, false, 0)}`,
            })}
          </h2>
          <Button
            color="black"
            variant="contained"
            radiusSize="large"
            className="w-[240px] h-[40px] rounded-20 !bg-[#282828] text-white !text-14"
            onClick={() => handleStartSharing()}
          >
            {t('startSharingButton')}
          </Button>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="container mx-auto flex flex-col items-center gap-18 rounded-12 mt-[50px] pb-[50px]">
          <p className="text-[13px] leading-[16px] font-br text-center">{t('title')}</p>
          <h2 className="text-[24px] leading-[29px] font-bb text-center whitespace-pre-line">
            {t('shareSaveAmount', {
              amount: `${formatPriceNumberWithSymbol(`${pointDollar}`, currency, false, 0)}`,
            })}
          </h2>
          <Button
            color="black"
            className="w-[240px] h-[36px] rounded-12 !bg-[#282828] text-white !text-14"
            variant="contained"
            radiusSize="large"
            onClick={() => handleStartSharing()}
          >
            {t('startSharingButton')}
          </Button>
        </div>
      </WapOnly>
    </>
  );
}
